import Dexie, {
	IndexableType,
	Table,
} from 'dexie';
import {
	Setting,
	DeviationModel,
	Assignment,
	RouteModel,
	DangerousGoodsModel,
	GateCounterModel,
} from 'models';
import {
	SettingKey,
} from '../enums/setting-key.enum';
import {
	QueuedHttpRequest,
} from 'utils/http';
import {
	takeCargoStoresSchemas,
} from '../take-cargo-schemas';
import {
	FeedbackModel,
} from 'models/feedback.model';


/**
 * The local TakeCargo database.
 * If you wish to update the database schema,
 * please refer to `take-cargo-schemas.ts` and the takeCargoStoresSchemas variable.
 *
 * For dexie documentation, please visit:
 * https://dexie.org/docs
 */
export class TakeCargoDatabase extends Dexie {
	assignments!: Table<Assignment, number>;
 	settings!: Table<Setting, SettingKey>;
	apiQueue!: Table<QueuedHttpRequest, IndexableType>;
	syncData!: Table<Setting, SettingKey>;
	syncNotification!: Table<Setting, SettingKey>;
	deviations!: Table<DeviationModel, number>;
	dangerousGoods!: Table<DangerousGoodsModel, number>;
	routes!: Table<RouteModel, number>;
	openGateCounter!: Table<GateCounterModel, number>;
	feedback!: Table<FeedbackModel, number>;

	constructor() {
  	super('TakeCargo');

  	/**
     * As the store version cannot be 0, we need to add 1 to the index.
     */
  	takeCargoStoresSchemas.forEach(
  		(schemas, index) => {
  			const versionNumber = index + 1;
  			this.version(versionNumber).stores(schemas);
  		});
	}
}